/**
 * Album the gallery viewer saves downloaded media into.
 *
 * The name/id are intentionally duplicated across the gallery effects (image.effects,
 * gallery.effects) so this shared constant keeps them in sync — any change to the
 * album target must go in one place.
 */
export const GALLERY_DOWNLOAD_ALBUM_NAME = 'Secacam';
export const GALLERY_DOWNLOAD_ALBUM_ID = 'secacam';
